import React, { useEffect, useRef, useState } from 'react'
import VideocamOffIcon from '@mui/icons-material/VideocamOff';
import axios from 'axios';
import { baseUrl, path } from '../../constants';
import VideoJS from './VideoJS';
import { Oval } from 'react-loader-spinner';
import CancelIcon from '@mui/icons-material/Cancel';
import FileIcon from '@mui/icons-material/FileCopy';
import { useQuery } from 'react-query';

export default function Materials({ sectionId, setSelected }) {
    const [loading, setLoading] = useState(true)
    
    const fileRef = useRef()
    const [files, setFiles] = useState([])
    const [uploading, setUploading] = useState(false)
    const [name, setName] = useState(null)
    const [sources, setSources] = useState(null)

    const { isLoading, error, data, refetch } = useQuery('fetchMaterials', () =>
        axios(baseUrl + path.getSectionMaterials + '/' + sectionId, {
        })
    )
    // const config = {
    //     onUploadProgress: progressEvent => console.log(progressEvent.loaded)
    // }

    
    const uploadFile = () => {
        if(!name || !sources.source) return alert('Invalid data!')
        setUploading(true)
        axios(baseUrl + path.uploadSectionMaterial + '/' + sectionId, {
            data: {
                name,
                type: sources.type,
                path: sources.source,
                size: sources.size
            },
            method: 'post',
        }).then(response => {
            if(response.data.success){
                setUploading(false)
                refetch()
            }
        }).catch(e => {
            alert(e)
            setUploading(false)
        })
    }
    const onChange = (event) => {
        setFiles([event.target.files[0]])
     }
  return (
    <div className='fixed inset-0 bg-[#00000070] flex items-center justify-center'>
        <div className='flex flex-col bg-white w-[70%] h-[80%] relative rounded-md gap-5'>
           <div className='flex w-full justify-center border-r-[1px] border-r-[#00000090] p-3 pt-5 gap-7'>
                <div className='flex gap-5 flex-col'>
                    <div className='flex gap-2 items-center'>
                        <input ref={fileRef} onChange={onChange} type='file' className='border-solid border-[1px] border-[#00000040] p-1' />
                        <button onClick={() => fileRef.current?.click()} className={`bg-black p-2 text-[12px] text-white`}>Change</button>
                    </div>
                    {!!files.length && <div className='flex flex-wrap gap-2'>
                        {files.map(file => (
                            <UploadItem file={file} setUploading={setUploading} setSources={setSources} />
                        ))}
                    </div> }
                </div>
                <input onChange={event => setName(event.target.value)} placeholder='Name' type='text' className='h-fit border-[1px] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-fit' />
                <button onClick={uploadFile} disabled={uploading} className='h-fit bg-main text-white text-[15px] p-2 rounded-sm'>
                    {uploading ? (
                        <Oval
                        visible={true}
                        height="25"
                        width="25"
                        color="#198754"
                        ariaLabel="oval-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        strokeWidth={3}
                    />
                ) : 'Save Material' }
                </button>
           </div>
           <div className='flex flex- flex-col'>
            <table className='border-[1px] border-[#00000050] border-collapse w-full' style={{
                padding: 10
            }}>
                <thead>
                    <tr className='bg-[#e2e2e2]'>
                        <th align='left' className='p-2'>File Name</th>
                        <th align='left' className='p-2'>Type</th>
                        <th align='left' className='p-2'>Size</th>
                        <th align='left' className='p-2'>Link</th>
                    </tr>
                </thead>
          
                    <tbody>
                        {data?.data?.materials?.map(material => (
                            <tr>
                                <td className='p-2 text-[14px] text-black'>{material.name}</td>
                                <td className='p-2 text-[14px] text-black'>{material.type?.toUpperCase()}</td>
                                <td className='p-2 text-[14px] text-black'>{(material.size / (1024 * 1024)).toFixed(2)} MB</td>
                                <td className='p-2 text-[14px] text-[#3161b5]'><a href={baseUrl + material.path} rel='noreferrer' target='_blank'>Open File</a></td>
                            </tr>
                        ))}
                    </tbody>
                
            </table>
            {isLoading && (
                        <div className='flex flex-col gap-3 flex-1 items-center p-5 justify-center'>
                            <p className='text-[16px]'>Loading section materials...</p>
                            <Oval
                                visible={true}
                                height="30"
                                width="30"
                                color="#198754"
                                ariaLabel="oval-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                                strokeWidth={3}
                            />
                        </div>
                ) }
           </div>
             <button onClick={() => setSelected(null)} className='absolute outline-none bg-white rounded-full bg-none -top-4 -right-4'>
                <CancelIcon style={{fontSize: 25, color: '#000000'}}>Filled</CancelIcon>
             </button>
        </div>
    </div>
  )
}


function UploadItem({ file, setUploading, setSources }){
    const [loading, setLoading] = useState(true)
    const [source, setSource] = useState(null)
    const [progress, setProgress] = useState(0)

    useEffect(() => {
        setLoading(true)
        let form  = new FormData()
        form.append('file', file)
        console.log(file)
        axios(baseUrl + path.uploadFile + '?to=materials', {
            data: form,
            method: 'post',
            onUploadProgress: progressEvent => {
                let prog = progressEvent.loaded / progressEvent.total
                console.log(prog)
                setProgress(prog * 100)
            },
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            if(response.data.success){
                console.log(response.data)
                setLoading(false)
                setSource(response.data)
                setSources(response.data)
            }
        })
    }, [file])

    return (
        <div className='border-[#00000050] border-solid border-[1px] p-1 flex items-center justify-center'>
            {loading ? (
                <div className='flex items-center gap-3'><Oval
                    visible={true}
                    height="24"
                    width="25"
                    color="#198754"
                    ariaLabel="oval-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    strokeWidth={3}
                /> <p className='text-[12px] text-black'>{progress.toFixed(1)}%</p></div> ): (
                    <div className='flex items-center gap-2'>
                        <FileIcon style={{fontSize: 20, color: '#000000'}}>Filled</FileIcon>
                        <p className='text-black text-[14px]'>{source.type}</p>
                    </div>
                )}
        </div>
    )
}